import { css, cx } from '@emotion/css';
import { theme } from 'antd';
import type React from 'react';

/**
 * Kurzname (identifier, always monospace) + Langbezeichnung (description). Emphasis follows
 * the role: primary = full color + weight 500, secondary = muted. flipParamNames swaps which
 * is primary. See .claude/rules/param-name-display.md.
 */
export const ParamNameTitle: React.FC<{
  shortName: string;
  longName: string;
  flipParamNames: boolean;
  /** Optional overrides to layer on size/weight without duplicating the mono/role/flip logic. */
  classNames?: { primary?: string; secondary?: string };
}> = ({ shortName, longName, flipParamNames, classNames }) => {
  const { token } = theme.useToken();

  const mono = css`
    font-family: ${token.fontFamilyCode};
  `;
  const primary = cx(
    css`
      font-weight: 500;
      color: ${token.colorText};
    `,
    classNames?.primary
  );
  const secondary = cx(
    css`
      font-weight: 400;
      color: ${token.colorTextSecondary};
      margin-left: ${token.marginXS}px;
    `,
    classNames?.secondary
  );

  const short = (cls: string) => <span className={cx(cls, mono)}>{shortName}</span>;
  const long = (cls: string) => <span className={cls}>{longName}</span>;

  return flipParamNames ? (
    <>
      {long(primary)}
      {short(secondary)}
    </>
  ) : (
    <>
      {short(primary)}
      {long(secondary)}
    </>
  );
};
